import http from '@/communication/AuthConnection'

export default async ({ commit }, params) => {
  try {
    const request = await http.get('/v1/board/event/details', { params })
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/get-event-details/index.js